import styled from '@emotion/styled';

export const LayoutRoot = styled.div`
  display: flex;
  width: 100%;
  min-height: 100dvh;
  background: #ffffff;
`;

export const PageArea = styled.div<{ $isMobile?: boolean }>`
  margin-left: ${({ $isMobile }) => ($isMobile ? 0 : '70px')};
  width: ${({ $isMobile }) => ($isMobile ? '100%' : 'calc(100% - 70px)')};
  height: 100dvh;
  display: flex;
  flex-direction: column;

  background: ${({ theme }) => (theme as any)?.token?.colorBgLayout || '#fff'};
`;

export const HeaderBar = styled.header<{ $isMobile?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const ContentWrapper = styled.main<{ $isMobile?: boolean }>`
  flex: 1;
  width: 100%;
  overflow: auto;
  margin-top: ${({ $isMobile }) => ($isMobile ? '56px' : '')};
`;

export const Top = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  gap: 16px;
  padding: ${({ $isMobile }) => ($isMobile ? '16px 16px 12px' : '12px 16px')};
`;

export const Bottom = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
`;

export const MobileActionsBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 12px 16px;
  background: ${({ theme }) => (theme as any)?.token?.colorBgContainer || '#fff'};
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  overflow: auto;
`;

export const MobileActionsContent = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 12px;
`;
